import React from "react";
import {useGlobalContext} from "../globalContext";
import {useTypedSelector} from "migration/shared/lib/hooks/useTypedSelector";
import {TranslateFn} from "../../utils/translate/translate";

/**
 * Binds I18nTranslate to the backend translate endpoint.
 *
 * The organisation is read from the store rather than taken as a prop. These
 * inputs are rendered from roughly twenty places, and a single Redux store
 * backs both halves of the app, so threading the same id through every call
 * site would buy nothing. It is the org being edited, not the signed-in user's
 * own - a staff user works on a selected org, which is why the server cannot
 * derive it from the session.
 *
 * Loading is a no-op here: each input already tracks its own in-flight state to
 * disable its button, and the global spinner would fight with it.
 */
export function useTranslate(): TranslateFn {
    const {api} = useGlobalContext();
    const {currentUser} = useTypedSelector((state) => state.user);
    const orgId = currentUser?.org?.id || "";

    return React.useCallback(
        (text: string, from: string, to: string[]) => api.translate(
            {setLoading: () => {}},
            {orgId, text, from, to},
        ),
        [api, orgId],
    );
}
